export interface LondonNeighbourhood {
  name: string;
  lat: number;
  lng: number;
  zoom: number;
}

export const LONDON_NEIGHBOURHOODS: LondonNeighbourhood[] = [
  { name: "Soho", lat: 51.5137, lng: -0.1337, zoom: 16 },
  { name: "Shoreditch", lat: 51.5265, lng: -0.0785, zoom: 15 },
  { name: "Brixton", lat: 51.4613, lng: -0.1156, zoom: 15 },
  { name: "Camden", lat: 51.5392, lng: -0.1426, zoom: 15 },
  { name: "Notting Hill", lat: 51.5093, lng: -0.1964, zoom: 15 },
  { name: "Mayfair", lat: 51.5095, lng: -0.1480, zoom: 16 },
  { name: "Covent Garden", lat: 51.5117, lng: -0.1240, zoom: 16 },
  { name: "Dalston", lat: 51.5464, lng: -0.0755, zoom: 15 },
  { name: "Peckham", lat: 51.4737, lng: -0.0693, zoom: 15 },
  { name: "Hackney", lat: 51.5450, lng: -0.0553, zoom: 15 },
  { name: "Islington", lat: 51.5362, lng: -0.1033, zoom: 15 },
  { name: "Clapham", lat: 51.4620, lng: -0.1680, zoom: 15 },
  { name: "Bermondsey", lat: 51.4979, lng: -0.0637, zoom: 15 },
  { name: "Fitzrovia", lat: 51.5200, lng: -0.1382, zoom: 16 },
  { name: "Clerkenwell", lat: 51.5237, lng: -0.1050, zoom: 15 },
  { name: "Borough", lat: 51.5013, lng: -0.0933, zoom: 15 },
  { name: "Canary Wharf", lat: 51.5054, lng: -0.0235, zoom: 15 },
  { name: "Greenwich", lat: 51.4769, lng: -0.0005, zoom: 15 },
  { name: "Bethnal Green", lat: 51.5270, lng: -0.0553, zoom: 15 },
  { name: "Kensington", lat: 51.4990, lng: -0.1939, zoom: 15 },
  { name: "Chelsea", lat: 51.4875, lng: -0.1687, zoom: 15 },
  { name: "Fulham", lat: 51.4730, lng: -0.2020, zoom: 15 },
  { name: "Battersea", lat: 51.4750, lng: -0.1480, zoom: 15 },
  { name: "Vauxhall", lat: 51.4861, lng: -0.1228, zoom: 15 },
  { name: "Waterloo", lat: 51.5036, lng: -0.1143, zoom: 15 },
  { name: "Southwark", lat: 51.5035, lng: -0.1048, zoom: 15 },
  { name: "Hoxton", lat: 51.5324, lng: -0.0767, zoom: 15 },
  { name: "Stoke Newington", lat: 51.5610, lng: -0.0740, zoom: 15 },
  { name: "Angel", lat: 51.5322, lng: -0.1058, zoom: 15 },
  { name: "King's Cross", lat: 51.5308, lng: -0.1238, zoom: 15 },
];

export function matchNeighbourhoods(query: string): LondonNeighbourhood[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return LONDON_NEIGHBOURHOODS.filter(n => {
    const words = n.name.toLowerCase().split(/\s+/);
    return words.some(w => w.startsWith(q)) || n.name.toLowerCase().startsWith(q);
  });
}

export function haversineDistance(
  lat1: number, lng1: number,
  lat2: number, lng2: number
): number {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}
